const BRAND_CURATION_TASKS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
  persistedFilters: {},
}

export default BRAND_CURATION_TASKS_INITIAL_STATE
